import { __assign, __awaiter, __generator } from '../../_virtual/_tslib.js';
import { debounce } from '../../node_modules/@superbet-group/web.lib.utilities/dist/index.esm.js';
import { useResizeTracking } from '@superbet-group/web.lib.vue-utilities';
import { ref, watch, onMounted, onBeforeUnmount } from '@vue/composition-api';

var defaultOptions = {
    direction: 'vertical',
    delay: 50,
    tolerancePx: 2,
};
function useScrollingTracker(elementRef, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var _a = __assign(__assign({}, defaultOptions), options), direction = _a.direction, delay = _a.delay, tolerancePx = _a.tolerancePx;
    var isScrolled = ref(false);
    var isScrollable = ref(false);
    var _b = useResizeTracking(elementRef), width = _b.width, height = _b.height;
    // Avoids rounding issues within the browser
    function isWithinTolerance(scrollSize, size) {
        return scrollSize - size >= tolerancePx;
    }
    function updateIsScrolledAndScrollableBase() {
        if (direction === 'vertical') {
            isScrolled.value = !!elementRef.value
                && elementRef.value.scrollTop > 0;
            isScrollable.value = !!elementRef.value
                && elementRef.value.scrollHeight > elementRef.value.clientHeight
                && isWithinTolerance(elementRef.value.scrollHeight, elementRef.value.scrollTop + elementRef.value.clientHeight);
        }
        else {
            isScrolled.value = !!elementRef.value
                && elementRef.value.scrollLeft > 0;
            isScrollable.value = !!elementRef.value
                && elementRef.value.scrollWidth > elementRef.value.clientWidth
                && isWithinTolerance(elementRef.value.scrollWidth, elementRef.value.scrollLeft + elementRef.value.clientWidth);
        }
    }
    var updateIsScrolledAndScrollable = delay > 0 ? debounce(updateIsScrolledAndScrollableBase, delay) : updateIsScrolledAndScrollableBase;
    watch(function () { return width.value; }, function (width, oldWidth) {
        if (direction === 'horizontal' && width !== oldWidth) {
            updateIsScrolledAndScrollable();
        }
    });
    watch(function () { return height.value; }, function (height, oldHeight) {
        if (direction === 'vertical' && height !== oldHeight) {
            updateIsScrolledAndScrollable();
        }
    });
    onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            (_a = elementRef.value) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', updateIsScrolledAndScrollable, { passive: true });
            updateIsScrolledAndScrollable();
            return [2 /*return*/];
        });
    }); });
    onBeforeUnmount(function () {
        var _a;
        (_a = elementRef.value) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', updateIsScrolledAndScrollable);
    });
    return {
        isScrollable: isScrollable,
        isScrolled: isScrolled,
    };
}

export { useScrollingTracker };
